import React, { Component } from 'react';

import LegendValues from '../b-LeafletMap/Legend/LegendValues';
import LegendCommune from '../b-LeafletMap/Legend/LegendCommune';
import LegendResidentialArea from '../b-LeafletMap/Legend/LegendResidentialArea';

import getMyMap, {createCommuneMassLayer, createResidentialAreasMassLayer,
                  getLegendMode, createCommuneBordersLayer, createCommunesNamesLayerEasy} from './leaflet_map';

import {c_missing_data, c_gradient_greens} from '../a-Graphic/Colors';

class LeafletMapProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      territory: props.territory,
      selected: "density_local",
      map_legend: null
    };

    this.mode = "ckmeans";
    this.colors = c_gradient_greens
  }

  componentDidMount() {
    // --- init map
    var mymap = this.mymap = getMyMap(this.props.id, true, 0.2);

    // --- create layers
    if (this.props.selected === "density_local"){
      var communeslayer = this.borderlayer = createCommuneBordersLayer(mymap, this.props.communes);
      var ra_pop = this.props.residential_areas.map((ra)=> ra.population)
      var ra_label = this.props.residential_areas.map((ra)=> ra.name + " - " + ra.population + " hab")
      var layer = this.layer = createResidentialAreasMassLayer(mymap, this.props.residential_areas, ra_pop, ra_label);

      // --- center the map
      mymap.fitBounds(communeslayer.getBounds());
    } else {
      var layer = this.layer = createCommuneMassLayer(mymap, this.props.communes, this.props.masses, this.props.labels, this.mode, this.colors);
      createCommunesNamesLayerEasy(mymap, this.props.communes)

      // --- center the map
      mymap.fitBounds(layer.getBounds());
    }
  }

  componentDidUpdate() {
    // --- update areas
    this.mymap.removeLayer(this.layer);
    if (this.borderlayer != null){
      this.mymap.removeLayer(this.layer);
    }
    // --- create layers
    if (this.props.selected === "density_local"){
      this.borderlayer = createCommuneBordersLayer(this.mymap, this.props.communes);
      var ra_pop = this.props.residential_areas.map((ra)=> ra.population)
      var ra_label = this.props.residential_areas.map((ra)=> ra.name + " - " + ra.population + " hab")
      this.layer = createResidentialAreasMassLayer(this.mymap, this.props.residential_areas, ra_pop, ra_label);
    } else {
      this.layer = createCommuneMassLayer(this.mymap, this.props.communes, this.props.masses, this.props.labels, this.mode, this.colors);
    }
  }

  render() {
    if (this.props.selected === "density_local"){
      var values = this.props.residential_areas.map((ra) => ra.population);
    } else {
      var values = this.props.masses;
    }
    var [intervals, colors] = getLegendMode(this.mode, values, this.colors);
    return(

        <div className="row align-items-end">
          <div className="col-10">
            <div style={{height: "500px"}} id={this.props.id}></div>
          </div>

          <div className="col-2 pl-0 pr-0">
             {this.props.selected === "density_local" ?
               <LegendResidentialArea label={this.props.legend_label} />
               :
               <LegendCommune label={this.props.legend_label} />
             }
            <LegendValues intervals={intervals} colors={colors}/>
          </div>
        </div>
    )
  }
}

export default LeafletMapProfile;
